import { invokeEdgeOrPresent } from '../../shared/supabase/invokeEdgeOrPresent';
import type { AiChatMessage, AiChatSendResult } from '../domain/aiTypes';

export async function sendAiChatMessage(
  branchId: string,
  messages: Pick<AiChatMessage, 'role' | 'content'>[]
): Promise<AiChatSendResult> {
  const { data, error, presented } = await invokeEdgeOrPresent('ai-chat', {
    body: { branchId, messages },
  }, {
    module: 'ai',
    op: 'ai.chat',
    fallbackMessage: 'Error del asistente',
  });
  if (error) {
    const status = error.context && 'status' in error.context ? error.context.status : undefined;
    const body = data as { error?: string; code?: string; retryAfterSeconds?: number } | null;
    const rateLimited = status === 429 || body?.code === 'rate_limited';
    return {
      ok: false,
      errorCode: rateLimited ? 'rate_limited' : body?.code,
      retryAfterSeconds: body?.retryAfterSeconds,
      error: rateLimited
        ? 'Alcanzaste el límite de uso. Podés volver a intentar más tarde.'
        : body?.error ?? (presented ? 'Algo falló. Reintentá en un momento.' : (error.message ?? 'Error del asistente')),
    };
  }
  return (data as AiChatSendResult | null) ?? { ok: false, error: 'Respuesta vacía' };
}
